import { Auth0Options, RedirectCallback, VueAuth0Wrapper } from './VueAuth0Wrapper';

const DEFAULT_REDIRECT_CALLBACK: RedirectCallback = () => window.history.replaceState(
  {}, document.title, window.location.pathname,
);

let instance: VueAuth0Wrapper;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}): VueAuth0Wrapper => {
  if (!instance) {
    instance = new VueAuth0Wrapper();
    instance.init(onRedirectCallback, redirectUri, options as Auth0Options);
  }

  return instance;
};
